import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { platformAPI } from "../services/api";

const NAV_ITEMS = [
  { to: "/signups", label: "New signups", icon: "🆕", badge: "signups" },
  { to: "/shops", label: "Shops", icon: "🏪" },
  { to: "/plans", label: "Plans", icon: "💳" },
  { to: "/analytics", label: "Analytics", icon: "📊" },
  { to: "/activation", label: "Activation", icon: "🚦" },
  { to: "/product-templates", label: "Product Templates", icon: "📦" },
  { to: "/catalog-requests", label: "Product requests", icon: "🙋" },
  { to: "/problem-reports", label: "Problem reports", icon: "🐞", badge: "reports" },
  { to: "/referrals", label: "Referrals", icon: "🎟️", badge: "referrals" },
  { to: "/releases", label: "Releases", icon: "🚀" },
  { to: "/settings", label: "Settings", icon: "⚙️" },
];

const linkClass = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
    isActive
      ? "bg-primary-600 text-white"
      : "text-slate-300 hover:bg-slate-800 hover:text-white"
  }`;

export default function Layout() {
  const { user, logout } = useAuth();
  const [counts, setCounts] = useState({ signups: 0, reports: 0, referrals: 0 });

  // The badge is how a new signup gets noticed; it refreshes with each page change
  const { pathname } = useLocation();
  useEffect(() => {
    platformAPI
      .signupCount()
      .then(({ data }) => setCounts((current) => ({ ...current, signups: data.pending })))
      .catch(() => {});
    platformAPI
      .problemReportCount()
      .then(({ data }) => setCounts((current) => ({ ...current, reports: data.open })))
      .catch(() => {});
    platformAPI
      .referralCount()
      .then(({ data }) => setCounts((current) => ({ ...current, referrals: data.waiting })))
      .catch(() => {});
  }, [pathname]);

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Pinned to the screen: a long page scrolls beside it instead of stretching it */}
      <aside className="sticky top-0 h-screen w-64 shrink-0 self-start bg-slate-900 flex flex-col">
        <div className="shrink-0 px-5 py-5 border-b border-slate-800">
          <h1 className="text-white font-bold text-lg">🛠️ Super Admin</h1>
        </div>
        <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass}>
              <span>{item.icon}</span>
              {item.label}
              {item.badge && counts[item.badge] > 0 && (
                <span className="ms-auto rounded-full bg-amber-400 px-2 py-0.5 text-xs font-bold text-slate-900">
                  {counts[item.badge]}
                </span>
              )}
            </NavLink>
          ))}
        </nav>
        <div className="shrink-0 px-4 py-4 border-t border-slate-800">
          <p className="text-slate-400 text-xs mb-2 truncate">{user?.name}</p>
          <button
            onClick={logout}
            className="w-full text-left text-sm text-slate-300 hover:text-white"
          >
            Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  );
}
